import React from 'react';
import {DesktopDatePicker, PickersDay} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import updateLocale from 'dayjs/plugin/updateLocale';
import {$moment} from "../../funcs";
import "pages/Styles/UIKit_v2.sass";
import { datePickerValueFromEntity } from "./dateEntityValue";

type Props = {
    input: React.RefObject<any>;
    isEditing: boolean;
    setIsEditing: (editing: boolean) => void;
    entity: any;
    initialCalendarDate?: string;
    updateEntity: Function;
    disabled?: boolean;
}

export const DatePickerField: React.FC<Props> = ({input, isEditing, setIsEditing, entity, initialCalendarDate, updateEntity, disabled = false}) => {
    dayjs.extend(updateLocale)
    dayjs.updateLocale('en', {
        weekStart: 1,
    })

    const getReferenceDate = () => {
        const initialValue = initialCalendarDate?.trim();
        if (!initialValue) {
            return undefined;
        }

        const parsedDate = $moment(initialValue, ['YYYY-MM-DDTHH:mm:ss', 'DD.MM.YYYY', 'YYYY-MM-DD'], true);
        if (!parsedDate.isValid()) {
            return undefined;
        }

        return dayjs(parsedDate.toDate());
    };

    const referenceDate = datePickerValueFromEntity(entity) ? undefined : getReferenceDate();

    return (
        <div className="entity-date-time-picker-v2">
        {/* DatePicker на тач-устройствах становится MobileDatePicker: поле read-only и сразу открывает календарь.
            DesktopDatePicker сохраняет ручной ввод и кнопку календаря справа — как раньше и как на десктопе. */}
        <DesktopDatePicker
            inputRef={input}
            slots={{
                day: PickersDay,
            }}
            dayOfWeekFormatter={(day) => {
                switch (day) {
                    case "Su":
                        return "Вс"
                    case "Mo":
                        return "Пн"
                    case "Tu":
                        return "Вт"
                    case "We":
                        return "Ср"
                    case "Th":
                        return "Чт"
                    case "Fr":
                        return "Пт"
                    case "Sa":
                        return "Сб"
                    default:
                        return day
                }
            }}
            slotProps={{
                day: { showDaysOutsideCurrentMonth: true },
                openPickerButton: { tabIndex: -1 },
                textField: {
                    size: "small",
                    sx: { width: "100%" },
                    placeholder: entity.inputPlaceholder?.trim() || "ДД.ММ.ГГГГ",
                    onFocus: () => {
                        if (!disabled) {
                            setIsEditing(true);
                        }
                    },
                    onBlur: () => {
                        setIsEditing(false);
                    },
                }
            }}
            disabled={disabled}
            format={"DD.MM.YYYY"}
            value={datePickerValueFromEntity(entity)}
            referenceDate={referenceDate}
            onOpen={() => {
                setIsEditing(true)
            }}
            onClose={() => {
                setIsEditing(false)
            }}
            onChange={(value: any) => {
                if (!value) {
                    updateEntity("");
                    return;
                }
                
                // Форматируем дату в формате DD.MM.YYYY с ведущими нулями
                const day = String(value.$D).padStart(2, '0');
                const month = String(value.$M + 1).padStart(2, '0');
                const year = value.$y;
                const formattedDate = `${day}.${month}.${year}`;
                
                // Просто передаем отформатированную дату
                updateEntity(formattedDate);
            }}
        />
        </div>
    );
};
